import { MotionInit } from "./base/motionInit";

const viewRoot = document.querySelector("html") as HTMLElement;
new MotionInit(viewRoot);
